import { ParametrosUnidades } from "./typings/unidade";
import axios from "infra/http";
import { useQuery } from "react-query";

function useParametrosUnidades(id: string) {
  return useQuery(
    `/v1/unidades/${id}/parametros`,
    async () => {
      const res = await axios.get<ParametrosUnidades>(
        `/v1/unidades/${id}/parametros`
      );

      return res.data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useParametrosUnidades;
